import isNumber from './is-number';
var isDecimal = function (num) {
    return isNumber(num) && num % 1 !== 0;
};
export default isDecimal;
//# sourceMappingURL=is-decimal.js.map